import { Component, computed, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SiEmptyStateComponent } from '@siemens/element-ng/empty-state';
import { NgxDatatableModule } from '@siemens/ngx-datatable';

import { BRouterSegment, LatLng } from '../../models/brouter-map.model';
import {
  buildTrackMessageTable,
  rowToLatLng,
  TrackMessageRow
} from '../../services/track-messages';

/**
 * Per-edge routing data, replacing the legacy DataTables `#datatable` sidebar tab.
 *
 * Long routes produce thousands of rows, so this uses the virtualising datatable
 * rather than a plain table.
 */
@Component({
  selector: 'app-route-data-table',
  imports: [TranslateModule, NgxDatatableModule, SiEmptyStateComponent],
  templateUrl: './route-data-table.component.html',
  styleUrl: './route-data-table.component.scss'
})
export class RouteDataTableComponent {
  readonly segments = input.required<readonly (BRouterSegment | null)[]>();

  /** Emits the position of the hovered row, or `null` when the pointer leaves the table. */
  readonly rowHovered = output<LatLng | null>();
  readonly closed = output<void>();

  private readonly table = computed(() => buildTrackMessageTable(this.segments()));

  readonly columns = computed(() => this.table().columns);
  readonly rows = computed(() => this.table().rows);
  readonly hasData = computed(() => this.rows().length > 0);

  onRowActivate(event: { type: string; row?: TrackMessageRow }): void {
    if (event.type === 'mouseenter' && event.row) {
      this.rowHovered.emit(rowToLatLng(event.row));
    }
  }

  onMouseLeave(): void {
    this.rowHovered.emit(null);
  }
}
